import CopyButton from '../../../components/CopyButton';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { Modal } from '../../../components/Modal';
import type { PromptOverride } from '../types/evalTypes';

interface DraftPromptModalProps {
  /** The arm whose draft is shown; `null` closes the modal. */
  armId: string | null;
  prompt: PromptOverride | undefined;
  loading?: boolean;
  error?: string | null;
  onClose: () => void;
}

/** The draft prompt text an arm ran with. */
export const DraftPromptModal = ({ armId, prompt, loading = false, error = null, onClose }: DraftPromptModalProps) => (
  <Modal isOpen={armId !== null} onClose={onClose} title={`Draft prompt: ${armId ?? ''}`} size="2xl">
    {loading && <LoadingSpinner message="Loading the draft prompt…" />}
    {error && <p className="text-sm text-red-700">{error}</p>}
    {!loading && !error && !prompt && <p className="text-sm text-gray-500">This run did not save the draft prompt of this arm.</p>}
    {!loading && prompt && (
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3 text-xs text-gray-500">
          <span>
            Hash <span className="font-mono">{prompt.promptHash}</span>, {prompt.prompt.length.toLocaleString()} characters
          </span>
          <CopyButton text={prompt.prompt} label="Copy" />
        </div>
        <pre className="text-xs font-mono whitespace-pre-wrap bg-gray-50 border border-gray-200 rounded p-3 max-h-[65vh] overflow-y-auto">
          {prompt.prompt}
        </pre>
      </div>
    )}
  </Modal>
);
